import { render, staticRenderFns } from "./VehicleSpecsTable.vue?vue&type=template&id=6245c18e&"
import script from "./VehicleSpecsTable.vue?vue&type=script&lang=js&"
export * from "./VehicleSpecsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports